import Vue from 'vue'
import app from '@/main'
// axios
import axios from 'axios'
import router from '@/router'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_HOST + "/api",
  // timeout: 1000,
  // UPDATE CLIENT - DEVICE FOR RATING
  headers: {'Client-Device': 'browser'},
  withCredentials: true
})

// axiosIns.interceptors.response.use(
//   res => res,
//   err => {
//       let { href } = router.resolve({name: 'login'})
//       if  (err.response.status === 401) {
//           router.push({name: 'login', query: { location: window.location.pathname }})
//       }
//       if (err.response.statusText === 'Unauthorized' && err.response.status === 404) {
//           router.push({name: 'catch-all', query: { location: window.location.pathname }})
//           app.$notif('Permission Denied', '', 'danger');
//       }
//       if (typeof err.response != 'undefined' && err.response.status === 403) {
//           app.$notif('Permission Denied', '', 'danger');
//       }
//       if (typeof err.response !== 'undefined')
//           return Promise.reject(err.response)
//       return Promise.reject(err)
//   })

axiosIns.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const skipGlobalErrorNotif = Boolean(err.config?.skipGlobalErrorNotif);

    if (!skipGlobalErrorNotif) {
      if (status === 401) {
        // router.push({name: 'login'})
        app.$notif('Welcome!', 'Please Log In First', 'info')
      }

      if (status === 403) {
        app.$notif('Permission Denied', '', 'danger');
      }

      if (status === 404) {
        const currentPath = window.location.pathname;
        if (router.currentRoute.name !== 'catch-all') {
          router.push({ name: 'catch-all', query: { location: currentPath } });
        }
        app.$notif('Page Not Found', '', 'danger');
      }
    }

    return Promise.reject(err.response ?? err);
  }
);

Vue.prototype.$http = axiosIns

export default axiosIns
